export const IN_ENTWICKLUNG = '18B001E28F2';
export const ABFRAGEN_FOR_ABMUSTERUNG = '18B001E4269';
export const ABFRAGEN_FOR_ABMUSTERUNG_QS = '18B618CFD5B';
export const DURCHFUEHRUNG_DOKUMENTATION = '18B001E58CE';
export const IN_FREIGABE = '18B001E64B2';
export const WARTE_AUF_KUNDE = '19204043A83';
export const ABGESCHLOSSEN = '18B001E70E4';
